import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Drafts.css";

const DRAFTS_KEY = "dmyor_vision_drafts";

const loadDrafts = () => {
  try { return JSON.parse(localStorage.getItem(DRAFTS_KEY)) || []; }
  catch { return []; }
};

const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

const Drafts = () => {
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(null);

  useEffect(() => {
    setDrafts(loadDrafts());
  }, []);

  const handleLoad = (draft) => {
    navigate("/dashboard/year-plans", { state: { draft } });
  };

  const handleDelete = (id) => {
    const updated = drafts.filter((d) => d.id !== id);
    localStorage.setItem(DRAFTS_KEY, JSON.stringify(updated));
    setDrafts(updated);
    setConfirmDelete(null);
  };

  return (
    <div className="drafts-page">

      <div className="drafts-header">
        <div className="drafts-eyebrow">Vision drafts</div>
        <h1 className="drafts-title">Saved Drafts</h1>
        <p className="drafts-sub">
          {drafts.length === 0
            ? "Nothing saved yet."
            : `${drafts.length} draft${drafts.length !== 1 ? "s" : ""}. Pick up where you left off.`}
        </p>
      </div>

      {drafts.length === 0 ? (
        <div className="drafts-empty">
          <div className="drafts-empty-icon">
            <i className="bx bx-file-blank" />
          </div>
          <p className="drafts-empty-title">No drafts saved</p>
          <p className="drafts-empty-body">
            While building a vision, hit <strong>Save Draft</strong> to save your
            progress here. You can come back, continue, or delete any time.
          </p>
          <button className="drafts-new-btn" onClick={() => navigate("/dashboard/year-plans")}>
            Start a new vision
          </button>
        </div>
      ) : (
        <>
          <div className="drafts-list">
            {drafts.map((draft) => {
              const categories = Object.keys(draft.openSections || {}).filter(
                (k) => draft.openSections[k]
              );
              return (
                <div key={draft.id} className="draft-card">
                  <div className="draft-card-body" onClick={() => handleLoad(draft)}>
                    <div className="draft-card-top">
                      <span className="draft-name">{draft.name || "Untitled Draft"}</span>
                      <span className="draft-year-pill">
                        {draft.durationInYears} {draft.durationInYears === 1 ? "yr" : "yrs"}
                      </span>
                    </div>
                    <div className="draft-card-meta">
                      <span className="draft-meta-item draft-meta-dim">
                        <i className="bx bx-pencil" />
                        {draft.filledCount || 0} {draft.filledCount !== 1 ? "categories" : "category"} written
                      </span>
                      {categories.length > 0 && (
                        <span className="draft-meta-item draft-meta-cats">
                          {categories.slice(0, 3).join(" · ")}
                          {categories.length > 3 && ` +${categories.length - 3}`}
                        </span>
                      )}
                      <span className="draft-meta-item">
                        <i className="bx bx-time-five" />
                        {formatDate(draft.savedAt)}
                      </span>
                    </div>
                  </div>

                  <div className="draft-card-actions">
                    {confirmDelete === draft.id ? (
                      <div className="draft-confirm-delete">
                        <span className="draft-confirm-label">Delete?</span>
                        <button
                          className="draft-btn-confirm"
                          onClick={() => handleDelete(draft.id)}
                        >
                          Yes
                        </button>
                        <button
                          className="draft-btn-cancel"
                          onClick={() => setConfirmDelete(null)}
                        >
                          No
                        </button>
                      </div>
                    ) : (
                      <>
                        <button
                          className="draft-btn-load"
                          onClick={() => handleLoad(draft)}
                        >
                          Continue
                        </button>
                        <button
                          className="draft-btn-delete"
                          title="Delete draft"
                          onClick={() => setConfirmDelete(draft.id)}
                        >
                          <i className="bx bx-trash" />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <p className="drafts-footer-note">Drafts are saved in your browser only.</p>
        </>
      )}
    </div>
  );
};

export default Drafts;
